import React from 'react'
import { Grid } from '@design-systems/canvas-ui'

type GridContainerProps = React.ComponentProps<typeof Grid.Container>

/**
 * Simple full width container helper, using canvas grid system
 *
 * @param props same as Grid.Container props
 * @returns
 */
export function Container(props: GridContainerProps) {
    return (
        // note that {...props} must come last to override this className
        <Grid.Container className="hc8-pa-1x" {...props}>
            <Grid.Item
                size={{
                    xs: 12,
                }}
            >
                {props.children}
            </Grid.Item>
        </Grid.Container>
    )
}
